"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = require("events");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Base class providing common functionality for an upload based on options
 * provided to a direct binary access-related instance.
 */
var UploadBase = /*#__PURE__*/function (_EventEmitter) {
  _inherits(UploadBase, _EventEmitter);

  var _super = _createSuper(UploadBase);

  /**
   * Initializes a new upload instance with the given options.
   *
   * @param {object} [options] Options controlling the upload.
   * @param {Object} [options.log] The object to use for logging messages during the upload process. If
   *  specified, the object should contain methods info(), warn(), debug(), and error(). Log information
   *  will be passed as parameters to these methods.
   */
  function UploadBase() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, UploadBase);

    _this = _super.call(this);
    _this.options = options;
    _this.log = options.log;
    return _this;
  }
  /**
   * Retrieves the options as passed to the upload process instance.
   *
   * @returns {object} Raw options.
   */


  _createClass(UploadBase, [{
    key: "getOptions",
    value: function getOptions() {
      return this.options;
    }
    /**
     * Uses the info() method of the provided logger to log information about the upload.
     */

  }, {
    key: "logInfo",
    value: function logInfo() {
      if (this.log) {
        for (var _len = arguments.length, theArguments = new Array(_len), _key = 0; _key < _len; _key++) {
          theArguments[_key] = arguments[_key];
        }

        this.log.info.apply(this.log, theArguments);
      }
    }
    /**
     * Uses the warn() method of the provided logger to log information about the upload.
     */

  }, {
    key: "logWarn",
    value: function logWarn() {
      if (this.log) {
        for (var _len2 = arguments.length, theArguments = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          theArguments[_key2] = arguments[_key2];
        }

        this.log.warn.apply(this.log, theArguments);
      }
    }
    /**
     * Uses the debug() method of the provided logger to log information about the upload.
     */

  }, {
    key: "logDebug",
    value: function logDebug() {
      if (this.log) {
        for (var _len3 = arguments.length, theArguments = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          theArguments[_key3] = arguments[_key3];
        }

        this.log.debug.apply(this.log, theArguments);
      }
    }
    /**
     * Uses the error() method of the provided logger to log information about the upload.
     */

  }, {
    key: "logError",
    value: function logError() {
      if (this.log) {
        for (var _len4 = arguments.length, theArguments = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          theArguments[_key4] = arguments[_key4];
        }

        this.log.error.apply(this.log, theArguments);
      }
    }
    /**
     * Sends an event to external consumers.
     *
     * @param {string} eventName The name of the event to send.
     * @param {object} eventData Will be included as the event's data.
     */

  }, {
    key: "sendEvent",
    value: function sendEvent(eventName, eventData) {
      this.emit(eventName, eventData);
    }
  }]);

  return UploadBase;
}(_events.EventEmitter);

exports.default = UploadBase;